import React, {useState, useEffect} from 'react';
import {createPortal} from 'react-dom';
import '../../css/Select.css';
import './PaymentMethodValueSelect.css';
import {getAllPaymentMethods, getProductAvailabilityPerDate} from "../../utils/requestUtils";
import ModalDiv from "../../ModalDiv";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import DecimalInput from "../common/DecimalInput";
import DatePicker from "react-datepicker";
import {
    calculateDaysDifference, formatDateToAmericanFormat, formatDateToString, formatLocalDate,
    parseLocalDate
} from "../../utils/utils";

const datePickerPopperContainer = ({children}) => createPortal(children, document.body);

const PaymentMethodValueSelect = (props) => {
    const {
        onClose,
        onConfirm,
        totalValue,
        paymentMethods,
        futureDueDate,
        forceDueDate,
        allowChangeValue = true,
        allowChangeDueDate = true,
        considerPaidAccordingToDueDate = true,
    } = props;

    const attentionColor = 'var(--attention-color)';
    const normalGreenColor = 'var(--normal-green-color)';
    const normalColor = 'var(--normal-color)';

    const newPaymentMethods = forceDueDate
        ? paymentMethods.map(item => ({...item, dueDate: formatLocalDate(forceDueDate)}))
        : paymentMethods;

    const [paymentMethodValues, setPaymentMethodValues] = useState(newPaymentMethods && newPaymentMethods.length > 0 ? newPaymentMethods : [{
        paymentMethod: {id: undefined},
        value: totalValue,
        baseValue: totalValue,
        dueDate: formatLocalDate(forceDueDate ? forceDueDate : new Date()),
        paid: considerPaidAccordingToDueDate && parseLocalDate(forceDueDate ? forceDueDate : new Date()) <= parseLocalDate(new Date())
    }]);
    const [typedTotalValue, setTypedTotalValue] = useState(0);
    const [typedTotalValuePaid, setTypedTotalValuePaid] = useState(0);
    const [typedTotalValuePending, setTypedTotalValuePending] = useState(0);
    const [paymentMethods_, setPaymentMethods_] = useState([]);

    useEffect(() => {
        getAllPaymentMethods().then((p) => setPaymentMethods_(p));
        const totalPaymentValueTyped = paymentMethodValues.reduce((acc, item) => acc + item.value, 0);
        if (totalPaymentValueTyped > 0 && totalPaymentValueTyped < totalValue) {
            const dueDate = forceDueDate ? forceDueDate : (futureDueDate ? futureDueDate : new Date());
            setPaymentMethodValues(prevPaymentMethodValues => [
                ...prevPaymentMethodValues,
                {
                    paymentMethod: {id: undefined},
                    value: 0,
                    baseValue: 0,
                    dueDate: formatLocalDate(dueDate),
                    paid: considerPaidAccordingToDueDate && parseLocalDate(dueDate) <= parseLocalDate(new Date())
                }
            ]);
        }
    }, []);

    function handlePaymentMethodSelected(index, id) {

        const paymentMethod = id ? paymentMethods_.find((p) => p.id === Number(id)) : undefined;

        setPaymentMethodValues((prevItems) => {
            const currentItem = prevItems[index];
            const baseValue = currentItem.baseValue || currentItem.value || 0;
            const feePercentage = paymentMethod?.fee || 0;
            const feeAmount = (baseValue * feePercentage) / 100;
            const totalValueWithFee = baseValue + feeAmount;

            return prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    paymentMethod: paymentMethod,
                    splits: paymentMethod?.allowSplit ? 1 : 0,
                    fee: paymentMethod?.fee || 0,
                    value: totalValueWithFee,
                    baseValue: baseValue,
                    feeAmount: feeAmount
                } : item
            );
        });

    }

    function handleValueChange(index, value) {

        setPaymentMethodValues((prevItems) => {

            const currentItem = prevItems[index];
            const baseValue = parseFloat(value);
            const feePercentage = currentItem.paymentMethod?.fee || 0;
            const feeAmount = (baseValue * feePercentage) / 100;
            const totalValueWithFee = baseValue + feeAmount;

            const updatedItems = prevItems.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        value: totalValueWithFee,
                        baseValue: baseValue,
                        feeAmount: feeAmount
                    }
                    : item
            );

                        // Calcular soma até o índice atual (considera todos os pagamentos iniciais que vêm antes do index)
            const sumUntilIndex = updatedItems.slice(0, index + 1).reduce((acc, item, i) => {
                if (i === index) {
                    // Item sendo editado: usar o novo valor (baseValue)
                    return acc + baseValue;
                }
                // Outros itens: usar baseValue ou value
                return acc + (item.baseValue || item.value || 0);
            }, 0);

            const difference = Math.round((totalValue - sumUntilIndex) * 100) / 100;
            
            // Construir lista final: manter apenas itens até o índice atual
            // Remover todas as linhas após o index (inclusive pagos e não pagos)
            const newPaymentMethodValues = [];
            
            // Adicionar todos os itens até o índice atual (preservando ordem)
            // Isso inclui os pagamentos iniciais que vêm antes do index
            for (let i = 0; i <= index; i++) {
                newPaymentMethodValues.push(updatedItems[i]);
            }
            
            // Se houver diferença (valor total digitado é menor que o valor total), adicionar um novo item para o restante
            if (difference > 0) {
                const dueDate = parseLocalDate(forceDueDate ? forceDueDate : futureDueDate ? futureDueDate : new Date());
                newPaymentMethodValues.push({
                    paymentMethod: {id: undefined},
                    value: (difference),
                    baseValue: (difference),
                    dueDate: formatLocalDate(dueDate),
                    paid: considerPaidAccordingToDueDate && parseLocalDate(dueDate) <= new Date()
                });
            }
            
            return newPaymentMethodValues;
        });


    }

    useEffect(() => {
        console.log('paymentMethodValues', paymentMethodValues);
        setTypedTotalValue(paymentMethodValues.reduce((acc, item) => acc + (item.baseValue || item.value), 0));
        setTypedTotalValuePaid(paymentMethodValues.filter(paymentMethodValue => paymentMethodValue.paid).reduce((acc, item) => acc + item.value, 0));
        setTypedTotalValuePending(paymentMethodValues.filter(paymentMethodValue => !paymentMethodValue.paid).reduce((acc, item) => acc + item.value, 0));
    }, [paymentMethodValues]);

    function handleSplitsChange(index, value) {
        setPaymentMethodValues((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    splits: Number(value)
                } : item
            )
        );
    }

    function handleConfirm() {
        const difference = Math.round((totalValue - typedTotalValue) * 100) / 100;

        if (difference > 0) {
            alert(`Valor informado (${typedTotalValue}) é menor que o valor total (${totalValue}).`);
            return;
        }

        if (difference < 0) {
            alert(`Valor informado (${typedTotalValue}) é maior que o valor total (${totalValue}).`);
            return;
        }

        if (paymentMethodValues.find((p) => p.value > 0 && (p.paymentMethod?.id === undefined) && p.paid)) {
            alert(`Informe a forma de pagamento do que já foi pago.`);
            return;
        }

        onConfirm(paymentMethodValues.filter((p) => p.value > 0));
    }

    async function handleDueDateItemChange(index, date) {

        setPaymentMethodValues((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    dueDate:
                        formatLocalDate(date),
                    paid: considerPaidAccordingToDueDate && (date) <= (new Date())
                } : item
            )
        );
    }

    function getBackgroundColor(paymentMethodValue) {

        if (!considerPaidAccordingToDueDate || paymentMethodValue.value === 0) {
            return normalColor;
        }
        if (!paymentMethodValue.paid)
            return attentionColor;

        return normalGreenColor;
    }

    const showFeeColumns = paymentMethodValues.some((p) => p.paymentMethod && p.paymentMethod.fee > 0);
    const showSplitColumn = paymentMethodValues.some((p) => p.paymentMethod?.allowSplit);

    return (
        <ModalDiv closeModal={onClose} style_={{minHeight: '350px', width: 'auto', maxWidth: '960px'}}>
            <div className="payment-method-value-select">
            <div className="header-label payment-method-value-select__title">Formas de Pagamento</div>
            <div className="select-list-container payment-method-value-select__table-wrap">
                <table className="payment-method-value-select__table">
                    <colgroup>
                        <col className="payment-method-value-select__col-method"/>
                        <col className="payment-method-value-select__col-due"/>
                        <col className="payment-method-value-select__col-value"/>
                        {showFeeColumns && (
                            <>
                                <col className="payment-method-value-select__col-fee"/>
                                <col className="payment-method-value-select__col-total"/>
                            </>
                        )}
                        {showSplitColumn && <col className="payment-method-value-select__col-splits"/>}
                    </colgroup>
                    <thead>
                    <tr>
                        <th>Forma</th>
                        <th>{forceDueDate ? 'Pagto.' : 'Venc.'}</th>
                        <th>Valor</th>
                        {showFeeColumns && (
                            <>
                                <th>Taxa</th>
                                <th>Total</th>
                            </>
                        )}
                        {showSplitColumn && <th>Parc.</th>}
                    </tr>
                    </thead>
                    <tbody>

                    {paymentMethodValues.map((paymentMethodValue, index) => (
                        <tr key={index} style={{backgroundColor: getBackgroundColor(paymentMethodValue)}}>
                            <td>
                                <select
                                    className="payment-method-value-select__method-select"
                                    name={`paymentMethod-${index}`}
                                    value={paymentMethodValue.paymentMethod?.id || ''}
                                    onChange={(e) => handlePaymentMethodSelected(index, e.target.value)}
                                >
                                    <option value="">Selecione</option>
                                    {paymentMethods_.map((paymentMethod, i) => (
                                        <option key={i} value={paymentMethod.id}>
                                            {paymentMethod.name}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <div className="payment-method-value-select__due-date" data-test={`due-date-${index}`}>
                                    <DatePicker
                                        name={`due-date-${index}`}
                                        className="datepicker payment-method-value-select__datepicker"
                                        selected={parseLocalDate(paymentMethodValue.dueDate)}
                                        onChange={(date) => handleDueDateItemChange(index, date)}
                                        dateFormat="dd/MM/yyyy"
                                        disabled={!allowChangeDueDate || forceDueDate}
                                        autoComplete="off"
                                        popperContainer={datePickerPopperContainer}
                                        popperPlacement="bottom-start"
                                        popperModifiers={[
                                            {
                                                name: 'preventOverflow',
                                                options: {
                                                    boundary: 'viewport',
                                                },
                                            },
                                        ]}
                                    />
                                </div>
                            </td>
                            <td>
                                <DecimalInput
                                    name={`payment-method-value-${index}`}
                                    key={paymentMethodValue.id}
                                    disabled={!allowChangeValue}
                                    className="payment-method-value-select__value-input"
                                    placeholder="0,00"
                                    value={paymentMethodValue.baseValue || paymentMethodValue.value}
                                    onChange={(e) => handleValueChange(index, e.target.value)}
                                />
                            </td>
                            {showFeeColumns && <>
                                <td>
                                <span className="payment-method-value-select__fee-text">
                                    {paymentMethodValue.paymentMethod?.fee || 0}% 
                                    ({paymentMethodValue.feeAmount ? paymentMethodValue.feeAmount.toFixed(2) : '0.00'})
                                </span>
                                </td>
                                <td>
                                    <div className="payment-method-value-select__total-cell">
                                        <span className="payment-method-value-select__total-value">
                                            R$ {paymentMethodValue.value.toFixed(2)}
                                        </span>
                                    </div>
                                </td>
                            </>}
                            {showSplitColumn && (
                                <td>
                                    {paymentMethodValue.paymentMethod?.allowSplit && (
                                        <input
                                            name={`splits-${index}`}
                                            type="number"
                                            className="payment-method-value-select__splits-input"
                                            step="1"
                                            placeholder="1"
                                            value={paymentMethodValue.splits}
                                            onChange={(e) => handleSplitsChange(index, e.target.value)}
                                        />
                                    )}
                                </td>
                            )}
                        </tr>
                    ))}


                    </tbody>
                </table>
            </div>
            <div className="payment-method-value-select__totals">
                {considerPaidAccordingToDueDate && (
                    <>
                        <div className="total-label"
                             style={{color: normalGreenColor, height: '37.6px', display: 'flex', alignItems: "center"}}>
                            Valor Pago: R$ {(typedTotalValuePaid || 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                        </div>
                        <div className="total-label"
                             style={{color: attentionColor, height: '37.6px', display: 'flex', alignItems: "center"}}>
                            Valor Restante: R$ {(typedTotalValuePending || 0).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                        </div>
                    </>
                )}
                <div className="total-label"
                     style={{height: '37.6px', display: 'flex', alignItems: "center"}}>
                    Valor Total:
                    R$ {(((typedTotalValuePaid || 0) + (typedTotalValuePending || 0)) || totalValue ) .toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}
                </div>
            </div>

            <ActionButtonsManagerView>
                <ConfirmButton onClick={handleConfirm}/>
            </ActionButtonsManagerView>
            </div>
        </ModalDiv>
    );
};

export default PaymentMethodValueSelect;
